const handleCopyLinks = () => {
  const perspectives = document.querySelectorAll( '[data-copy-perspective-link]' )

	perspectives.forEach( perspective => {
		perspective.addEventListener( 'click', () => {
			console.log( perspective )
			const currentPerspective = perspective.closest( '.perspective' )
			const linkToCopy = currentPerspective.querySelector( '[data-perspective-link-to-copy]' )
			console.log( linkToCopy )
			linkToCopy.select()
			linkToCopy.setSelectionRange( 0, 99999 )
			document.execCommand( 'copy' )
			perspective.focus()
			const copyNotification = perspective.querySelector( '[data-fade-out-copy]' )
			copyNotification.classList.remove( 'dn' )
			copyNotification.classList.remove( 'fade-out' )
			copyNotification.classList.add( 'fade-out' )
		} )
	} )
}

document.addEventListener( 'DOMContentLoaded', () => handleCopyLinks() )
